module.exports = __webpack_public_path__ + "05_short_brown.c6ba754b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_short_brown.png
// module id = pxqg
// module chunks = 0